import React from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import RelatorioMaisOfertados from "../components/RelatorioMaisOfertados";
const RelatorioMaisOfertadosPage = () => {
    return (
        <>
            <div className="main-content">
                <Navbar/>
            </div>
            <div className="content">
                <Sidebar/>
            </div>
            <div className='table-mais-ofertados'>
                <RelatorioMaisOfertados/>
            </div>
        </>
    );
};

export default RelatorioMaisOfertadosPage;